import { render, staticRenderFns } from "./Insupanel.vue?vue&type=template&id=1d23f248"
import script from "./Insupanel.vue?vue&type=script&lang=js"
export * from "./Insupanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports